// Design layers first, so a component's own stylesheet always comes after them.
import "@fontsource-variable/montserrat/wght.css";
import "./design/tokens.css";
import "./design/base.css";
import "./design/glass.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { router } from "./app/router";

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root element");

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
